// src/components/auth/verification/VerificationContainer.tsx
// Path: /src/components/auth/verification/VerificationContainer.tsx
// Updated to fix verified prop logic and add debug logs for rendering conditions

import React from 'react';
import Pending from './Pending';
import Verification from './Verification';
import { observer } from 'mobx-react';
import { useUserStore } from '../../../stores/UserStore';
import { Helmet } from 'react-helmet-async';
import styled from 'styled-components';

const VerificationContainerStyled = styled.div`
  animation: fadeIn 1.5s ease-in;
  padding: 20px;
  max-width: 1200px;
  margin: 0 auto;
  text-align: center;

  @media (max-width: 768px) {
    padding: 10px;
    .ant-card,
    .ant-btn {
      font-size: 14px !important;
    }
  }
`;

interface VerificationContainerProps {
  verified?: string | boolean; // Allow string or boolean for compatibility
}

interface User {
  submittedForVerification?: boolean;
}

interface UserStore {
  user: User | null;
  verified: boolean;
}

const VerificationContainer: React.FC<VerificationContainerProps> = ({ verified: propVerified }) => {
  const userStore = useUserStore();
  const isVerified = userStore.verified || propVerified === true || propVerified === 'Verified';

  console.log(
    'VerificationContainer: Rendering - user:', userStore.user,
    'submittedForVerification:', userStore.user?.submittedForVerification,
    'isVerified:', isVerified,
    'propVerified:', propVerified
  );

  if (!userStore.user) {
    console.log('VerificationContainer: No user, rendering login prompt');
    return (
      <VerificationContainerStyled className="verification-container">
        <Helmet>
          <title>Please Log In - One Light System OLS</title>
          <meta
            name="description"
            content="Log in to verify your account with One Light System OLS Sun Light Meditation education."
          />
        </Helmet>
        <h2>Please log in to proceed with verification.</h2>
      </VerificationContainerStyled>
    );
  }

  return (
    <VerificationContainerStyled className="verification-container">
      <Helmet>
        <title>
          {userStore.user.submittedForVerification && !isVerified
            ? 'Pending Verification'
            : 'Account Verification'} - OLS
        </title>
        <meta
          name="description"
          content={
            userStore.user.submittedForVerification && !isVerified
              ? 'Your verification is pending with One Light System OLS.'
              : 'Verify your account for OLS Sun Light Meditation education.'
          }
        />
      </Helmet>
      {userStore.user.submittedForVerification && !isVerified ? (
        <>
          {console.log('VerificationContainer: Rendering Pending.tsx')}
          <Pending />
        </>
      ) : (
        <>
          {console.log('VerificationContainer: Rendering Verification.tsx')}
          <Verification />
        </>
      )}
    </VerificationContainerStyled>
  );
};

export default observer(VerificationContainer);